import equal from "deep-equal";
import { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import { createEnumParam, useQueryParams, withDefault } from "use-query-params";

import RadioButtonGroup from "@components/fields/RadioButtonGroup";
import Form from "@components/forms/Form";
import { JourneyStatusEnum } from "@typing/Enums";

type FormData = {
  status?: JourneyStatusEnum | null;
};

type Props = {
  filters: FormData;
  onChange: (filterValues: FormData) => void;
};

const WorksheetFilters = ({ filters, onChange }: Props) => {
  const intl = useIntl();

  const statusParam = createEnumParam<JourneyStatusEnum>(Object.values(JourneyStatusEnum));

  const [query, setQuery] = useQueryParams({
    status: withDefault({ ...statusParam, urlName: "worksheetStatus" }, filters.status)
  });

  const defaultValues: FormData = query;

  const form = useForm<FormData>({
    defaultValues,
    mode: "onChange"
  });

  const status = form.watch("status");

  useEffect(() => {
    const values = { status };
    if (!equal(values, filters)) {
      setQuery(values);
      onChange(values);
    }
  }, [filters, onChange, setQuery, status]);

  const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  const statusOptions = useMemo(() => {
    const options = [JourneyStatusEnum.IN_PROGRESS, JourneyStatusEnum.COMPLETED].map(option => ({
      label: capitalize(intl.formatMessage({ id: `models.status.${option}` })),
      value: option as string | null
    }));

    options.unshift({ label: intl.formatMessage({ id: "dictionary.all" }), value: null });

    return options;
  }, [intl]);

  return (
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    <Form hookForm={form} onSubmit={() => {}}>
      <RadioButtonGroup<FormData>
        control={form.control}
        error={form.formState.errors.status}
        name="status"
        noSpacing
        options={statusOptions}
      />
    </Form>
  );
};

export default WorksheetFilters;
